export default __webpack_public_path__ + "static/O0077-7f264cda8b1e8d689a7fae1a2c3caa85.png";